export default __webpack_public_path__ + "static/media/Fifty2.3acceb58.jpeg";